<ejs-tooltip [content]="'header.language' | translate" target=".lang-menu__trigger" position="BottomCenter">
  <button type="button"
          class="lang-menu__trigger"
          [attr.aria-label]="'header.language' | translate"
          aria-haspopup="true"
          [attr.aria-expanded]="isOpen()"
          [disabled]="!enabled()"
          (click)="toggle()">
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.0367 20.5464L17.7134 10.8507C17.48 10.2128 16.9576 9.81848 16.3574 9.81848C15.7573 9.81848 15.246 10.2128 14.9903 10.8739L11.6782 20.5464C11.5226 20.9988 11.7449 21.4975 12.1784 21.6598C12.6118 21.8222 13.0898 21.5903 13.2454 21.1379L13.9345 19.1315H18.7693L19.4584 21.1379C19.5807 21.4975 19.903 21.7178 20.2475 21.7178C20.3365 21.7178 20.4365 21.7062 20.5254 21.6714C20.9589 21.5091 21.1812 21.0104 21.0256 20.558L21.0367 20.5464ZM14.5458 17.3802L16.3686 12.0569L18.1913 17.3802H14.5458ZM11.7116 7.18578C9.19965 11.3262 6.93229 13.8313 4.17588 15.5014C4.0425 15.5826 3.89802 15.6174 3.76464 15.6174C3.47566 15.6174 3.1978 15.4666 3.04219 15.1883C2.80879 14.7707 2.94216 14.2372 3.34229 14.0053C5.67633 12.5904 7.58805 10.5607 9.73316 7.19738H2.7421C2.2864 7.19738 1.90851 6.80305 1.90851 6.32754C1.90851 5.85203 2.2864 5.4577 2.7421 5.4577H6.91006V3.16134C6.91006 2.68583 7.28796 2.2915 7.74365 2.2915C8.19934 2.2915 8.57725 2.68583 8.57725 3.16134V5.4577H12.7452C13.2009 5.4577 13.5788 5.85203 13.5788 6.32754C13.5788 6.80305 13.2009 7.19738 12.7452 7.19738H11.7004L11.7116 7.18578ZM11.756 15.6174C11.6115 15.6174 11.467 15.5826 11.3337 15.5014C10.6112 15.0607 9.91099 14.5736 9.25522 14.0633C8.88844 13.7733 8.81065 13.2282 9.08852 12.8455C9.36638 12.4628 9.88876 12.3816 10.2555 12.6715C10.8557 13.147 11.5115 13.5878 12.1784 13.9937C12.5785 14.2372 12.7119 14.7707 12.4785 15.1883C12.3229 15.4666 12.045 15.6174 11.756 15.6174Z" fill="currentColor"/>
    </svg>
  </button>
</ejs-tooltip>

@if (isOpen()) {
  <ul class="lang-menu__panel" role="menu">
    @for (lang of languages; track lang.code) {
      <li role="none">
        <button type="button"
                role="menuitemradio"
                [attr.aria-checked]="lang.code === current()"
                class="lang-menu__item"
                [class.is-active]="lang.code === current()"
                (click)="choose(lang.code)">
          <span class="lang-menu__label">{{ lang.label }}</span>
          @if (lang.code === current()) {
            <span class="lang-menu__check" aria-hidden="true">✓</span>
          }
        </button>
      </li>
    }
  </ul>
}
